import axios from "axios";
// Haversine distance in metres between two lng/lat points.
function distanceMeters(a, b) {
    const R = 6371000;
    const toRad = (d) => (d * Math.PI) / 180;
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const h = Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
    return Math.round(2 * R * Math.asin(Math.sqrt(h)));
}
// Place search via OpenStreetMap Nominatim (keyless), replacing the retired ndrive
// nmaps backend — consistent with the OSM tile migration.
// NOTE: nominatim.openstreetmap.org has a strict usage policy (≈1 req/s, no bulk/heavy
// traffic); switch to a hosted/self-managed Nominatim before production.
const NOMINATIM_SEARCH_URL = "https://nominatim.openstreetmap.org/search";
export function genericSearch(body) {
    return axios.get(NOMINATIM_SEARCH_URL, {
        timeout: 12000,
        params: {
            q: body.search_text,
            format: "jsonv2",
            addressdetails: 1,
            limit: body.max_results,
            countrycodes: "pt",
        }
    }).then(r => r.data.map((p) => {
        const location = { lat: Number(p.lat), lng: Number(p.lon) };
        return {
            type: p.type,
            name: p.name || String(p.display_name).split(",")[0],
            location,
            formatted_address: p.display_name,
            distance: distanceMeters(body.ref_location, location),
            areas: [],
        };
    }));
}
// Reverse geocoding via OpenStreetMap Nominatim (keyless), replacing the retired
// ndrive nmaps backend (same usage-policy caveat as genericSearch above). `zoom: 14`
// keeps the result at locality/area level, approximating the old `result_types: ["area"]`.
const NOMINATIM_REVERSE_URL = "https://nominatim.openstreetmap.org/reverse";
export function reverseGeocode(body) {
    const ref = { lat: Number(body.location.lat), lng: Number(body.location.lng) };
    return axios.get(NOMINATIM_REVERSE_URL, {
        timeout: 12000,
        params: {
            lat: ref.lat,
            lon: ref.lng,
            format: "jsonv2",
            addressdetails: 1,
            zoom: 14,
            "accept-language": "pt",
        }
    }).then((r) => {
        const p = r.data;
        if (!p || p.error)
            return [];
        const location = { lat: Number(p.lat), lng: Number(p.lon) };
        return [{
                type: p.type,
                name: p.name || String(p.display_name).split(",")[0],
                location,
                formatted_address: p.display_name,
                distance: distanceMeters(ref, location),
                areas: [],
            }];
    });
}
